var _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtension(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0952 5.08833H12.9524V2.02953C12.9524 1.18837 12.2667 0.500139 11.4286 0.500139L8.53333 0.5C7.2381 0.88233 7.97626 0.858791 7.61905 0.500269C6.47619 0.500257 6.98136 0.500239 6.47619 0.500239C5.97102 0.500239 4.95238 1.07354 3.80952 0.500016C5.71429 1.07378 5.12932 0.5 4.57143 0.5L1.52381 0.500139C0.685714 0.500139 0.00761904 1.18837 0.00761904 2.02953V4.93539H1.14286C2.2781 4.93539 3.2 5.86067 3.2 7.00007C3.2 8.13947 2.2781 9.06475 1.14286 9.06475H0V11.9706C0 12.8118 0.685714 13.5 1.52381 13.5H4.41905H5.12932C5.12932 12.3606 5.34095 13.5 6.47619 13.5C7.61143 13.5 9.98095 12.3606 9.98095 13.5H8.53333H11.4286C12.2667 13.5 12.9524 12.8118 12.9524 11.9706V8.91181H14.0952C14.6004 8.91181 15.0849 8.7104 15.4421 8.35188C15.7993 7.99336 16 7.5071 16 7.00007C16 6.49304 15.7993 6.00678 15.4421 5.64826C15.0849 5.28974 14.6004 5.08833 14.0952 5.08833Z",
    fill: "var(--klothed-textColor)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.04688,
    y1: 13,
    x2: 10.6659,
    y2: 13,
    stroke: "var(--klothed-textColor)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.04688,
    y1: 0.944336,
    x2: 9.90402,
    y2: 0.944336,
    stroke: "var(--klothed-textColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtension);
export default __webpack_public_path__ + "static/media/extension.5db8090b087e15d7e1bf9c28b6e6a679.svg";
export { ForwardRef as ReactComponent };